import React, { FC, useRef, useEffect } from "react";
// layout
import Layout from "../../components/layout";
import SectionForm from "../../components/home2/sectionForm";
import SectionSteps from "../../components/home2/sectionSteps";
import SectionH2h from "../../components/home2/sectionHome2home";

interface HomePageInterface {}

const HeaderFilter: FC<HomePageInterface> = () => {
  // const refH2h = useRef();
  useEffect(() => {

  }, []);

  return (
    <Layout>
      <>
        <SectionForm />
        <SectionSteps />
        <SectionH2h />
      </>
    </Layout>
  );
};

export default HeaderFilter;
